import { IconLoader } from '@ui/src';
import { StatusTitle } from '../../hoc/cash-collection/types';
import StatusItem from './status-item';
import { StatusesTypes } from './types';

import cn from './styles.module.css';

const PaymentOrderStatuses = ({
  statuses,
  status,
  disabled,
  onUpdate,
  isFetching,
  isLoading,
  isEditable,
}: StatusesTypes) => (
  <div className={cn.statusesWrapper}>
    <div className={cn.currentStatus}>
      {/* @ts-ignore */}
      <div className={cn.statusName}>{StatusTitle[status as StatusTitle]}</div>
      <div className={cn.statusNameCurrentText}>Current status</div>
    </div>
    {(isLoading || (isFetching && !statuses)) && (
      <div className={cn.statusesIsLoading}>
        <IconLoader />
      </div>
    )}
    {isEditable &&
      statuses?.next?.map((item) => (
        <StatusItem
          key={item.statusNext}
          item={item}
          updateStatusIsLoading={disabled}
          onUpdate={onUpdate}
          isFetching={isFetching}
        />
      ))}
  </div>
);

export default PaymentOrderStatuses;
